import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { PhysicalProductListItem } from '../../../../core';
import { IPhysicalProductVariationListItem } from '../../../models';

export interface IDiscountChangeMessage {
    variationID: string;
    discount?: number;
}

class ProductEditDiscount implements ng.IController {
    public variation: IPhysicalProductVariationListItem;
    public product: PhysicalProductListItem;
    public waiting: boolean;
    public onDiscountChange: (message: any) => any;
    public onCancelDiscount: (message: any) => any;

    public saveVariationStaffDiscount() {
        const message = {
            product: this.product,
            variation: this.variation
        };
        this.onDiscountChange({changedDiscount: message});
    }

    public changeVariationStaffDiscount(discountMessage: IDiscountChangeMessage) {
        this.variation.discount = discountMessage.discount;
    }

    public cancelDiscount() {
        this.onCancelDiscount({value: true});
    }
}

angular.module('naut').component('productEditDiscount', {
    template: require('./edit-discount-for-staff-modal.component.html'),
    controller: ProductEditDiscount,
    controllerAs: 'vm',
    bindings: {
        variation: '<',
        product: '<',
        waiting: '<',
        onDiscountChange: '&',
        onCancelDiscount: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/modals/edit-discount-for-staff/edit-discount-for-staff-modal.component.ts